module.exports = __webpack_public_path__ + "img/circularStrategy3.cc897699.png";